import type { Extension, Patient, Practitioner } from '@medplum/fhirtypes';
import { ALIASES_EXT, BIO_EXT, CLINICAL_EXT } from '@unify/fhir-model/constants';
import type { User } from '../pages/users/types/rbac';

/** Apply the profile fields shared by Practitioner and Patient settings forms. */
export function upsertProfileExtensions<T extends Practitioner | Patient>(
  resource: T,
  updates: Pick<Partial<User>, 'bio' | 'aliases' | 'clinical'>,
): T {
  let extensions: Extension[] = resource.extension ?? [];

  if (updates.bio !== undefined) {
    extensions = extensions.filter((extension) => extension.url !== BIO_EXT);
    if (updates.bio !== '') extensions.push({ url: BIO_EXT, valueString: updates.bio });
  }

  if (updates.aliases !== undefined) {
    extensions = extensions.filter((extension) => extension.url !== ALIASES_EXT);
    if (updates.aliases.length) {
      extensions.push({ url: ALIASES_EXT, valueString: JSON.stringify(updates.aliases) });
    }
  }

  if (updates.clinical !== undefined) {
    extensions = extensions.filter((extension) => extension.url !== CLINICAL_EXT);
    if (Object.keys(updates.clinical).length > 0) {
      extensions.push({ url: CLINICAL_EXT, valueString: JSON.stringify(updates.clinical) });
    }
  }

  return { ...resource, extension: extensions };
}
